import { List } from "./List";

const BulkEmail = {
  List,
};

export default BulkEmail;
